import { useEffect, useState } from "react";

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleChat = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent("toggle-ai-chat"));
  };

  return (
    <button
      onClick={toggleChat}
      aria-label="Chat with AI Assistant"
      className={`
        fixed bottom-7 right-7
        bg-blue-600 text-white font-bold text-sm
        px-6 py-4 rounded-full
        shadow-[0_8px_32px_rgba(37,99,235,0.5)]
        z-[999]
        transition-all duration-300
        flex items-center gap-2
        
        ${visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-5 pointer-events-none"
        }
        
        hover:bg-blue-700 hover:-translate-y-1
        hover:shadow-[0_12px_40px_rgba(37,99,235,0.6)]
      `}
    >
      <span className="flex h-2 w-2 rounded-full bg-green-400 animate-pulse" />
      Quick Help
    </button>
  );
}